import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { catchError, map, of, tap } from 'rxjs';
import { AuthService } from './auth.service';

// El login vive en otro subdominio (unilogin): sin sesión válida se sale de la app.
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);

  return auth.entrarAlModulo().pipe(
    map(() => true),
    catchError(() => {
      auth.irAlLogin();
      return of(false);
    }),
  );
};

// Encuesta del trabajador: sólo exige sesión, sin entrar al módulo GEM (aún no está en
// car.modulo). El trabajador llega desde unilogin con NOM-035 abierto.
export const sesionGuard: CanActivateFn = () => {
  const auth = inject(AuthService);

  return auth.getLogAcceso().pipe(
    tap((sesion) => auth.sesion.set(sesion)),
    map(() => true),
    catchError(() => {
      auth.irAlLogin();
      return of(false);
    }),
  );
};
